enum RISQUE_METEO {
  NA = "Non renseigné",
  FAIBLE = "Faible",
  LEGER = "Léger",
  MODERE = "Modéré",
  SEVERE = "Sévère",
  TRES_SEVERE = "Très sévère",
  EXTREME = "Extrême",
}

export default RISQUE_METEO;
